import React, { useMemo } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { Typography, Link } from '@mui/material';

// Fora do componente: um array literal novo a cada render faria o
// react-markdown reconstruir o pipeline de plugins a cada delta do streaming.
const PLUGINS_REMARK = [remarkGfm];

/**
 * Renderiza o conteudo da mensagem como Markdown.
 *
 * A OpenAI responde em Markdown (negrito, listas, tabelas), nao em HTML. Antes
 * o texto era impresso cru num Typography, entao o usuario via os "**" e os "-"
 * literais no lugar da formatacao.
 *
 * react-markdown converte para elementos React -- nunca gera HTML cru, entao
 * nao ha caminho para XSS por construcao e nao precisamos sanitizar. Isso
 * importa aqui porque o conteudo vem de um LLM, que por sua vez pode estar
 * repetindo texto de uma base de conhecimento: conteudo nao confiavel.
 *
 * Durante o streaming este componente re-renderiza a cada delta (as vezes um
 * unico caractere), por isso o memo e os objetos estaveis.
 */
function MensagemMarkdown({ conteudo }) {
  const componentes = useMemo(
    () => ({
      // Links do LLM sempre abrem em nova aba, com rel de seguranca para o
      // destino nao alcancar window.opener.
      a: ({ node, ...props }) => <Link {...props} target="_blank" rel="noopener noreferrer" />,
      table: ({ node, ...props }) => (
        <div className="chat-ia-markdown-tabela">
          <table {...props} />
        </div>
      )
    }),
    []
  );

  if (!conteudo) {
    return null;
  }

  return (
    <Typography variant="body2" component="div" className="chat-ia-markdown">
      <ReactMarkdown remarkPlugins={PLUGINS_REMARK} components={componentes}>
        {conteudo}
      </ReactMarkdown>
    </Typography>
  );
}

// Re-renderiza so quando o texto muda: as bolhas ja concluidas ficam paradas
// enquanto apenas a ultima recebe os deltas.
export default React.memo(MensagemMarkdown);
